import { env } from "./config";

export function showToast(toast, message, severity = 'success', seconds = 5000, title = ''){
    const severities = ['success','info','warn','error','secondary','contrast'];
    if(!severities.includes(severity))
        severity = 'success';
    if(title == '')
        title = env('APP_NAME');
    // PrimeVue keeps this object until dismissal/expiry. Resolve optional UI copy
    // during rendering so a locale change updates it without adding another toast
    // or resetting its lifetime. String consumers retain their previous behavior.
    const notification = { severity: severity, summary: title, life: seconds };
    if (typeof message === 'function') {
        Object.defineProperty(notification, 'detail', {
            enumerable: true,
            get: () => message() + (severity === 'error' ? '!' : '')
        });
    } else {
        notification.detail = severity === 'error' ? message + '!' : message;
    }
    toast.add(notification);
    let toastEl = document.querySelector('.p-toast');
    toastEl.style.left = 'unset';
    let screenWidth = window.innerWidth;
    if(screenWidth < 450 && (toastEl != null && toastEl != undefined)){
      let percent = screenWidth / 100;
      let margin = percent * 5;
      toastEl.style.width = (percent * 90) + 'px';
      toastEl.style.right = margin + 'px';
      toastEl.style.left  = margin + 'px';
    }
}
